import toast from 'react-hot-toast';
import useApi from '../useApi';
import { ISendChatReq,ISendChatRes } from './index.type';
// { receiverId }: { receiverIdclinicId?: string }

const useSendChat = () => {
  const url = '/RTM/sendMessage' ;
  const method =  'POST';


  const { loading: sendChatLoading, makeApiCall } = useApi({ url, method });

  const sendChat = async (formData: ISendChatReq) => {
    const { response, error } = await makeApiCall<ISendChatReq,  ISendChatRes>(formData);
    if (response?.status) {
      return response;
    }

    if (error || !response?.status) {
      toast.error(error?.msg || 'Failed to send message. Please check your connection and try again.');
      return { status: false };
    }
  };

  return {
    sendChatLoading,
    sendChat,
  };
};

export default useSendChat ;
